export function isAtlassianUser(userEmail: string): boolean {
	return userEmail.endsWith('@atlassian.com');
}
